
export class ReqDepartmentList {
    constructor({ companyId, start, limit }) {
        this.companyId = companyId
        this.start = start
        this.limit = limit
    }

    fromJson(jsonData) {
        this.companyId = jsonData.companyId
        this.start = jsonData.start
        this.limit = jsonData.limit
    }
}

export class RespDepartmentList {
    constructor(status) {
        this.status = status;
    }
    fromJson(jsonDate) {
        this.status = jsonDate.status
        this.list = []
        jsonDate.list.map((json) => {
            var company = new RespDepartment()
            company.fromJson(json)
            this.list.push(company)
        })

        this.count = jsonDate.count
        this.disableCount = jsonDate.disableCount
        this.enableCount = jsonDate.enableCount
    }
}

export class RespDepartment {
    constructor({ companyId, departmentId, departmentName, managerDepartmentId, isDisable }) {
        if (companyId !== undefined)
            this.companyId = companyId
        if (departmentId !== undefined)
            this.departmentId = departmentId
        this.managerDepartmentId = managerDepartmentId
        this.departmentName = departmentName
        this.managerDepartmentId = managerDepartmentId
        this.isDisable = isDisable
    }
    /*
    constructor(companyName) {
        this.companyName = companyName;
    }
    */

    fromJson(jsonDate) {
        //console.log(jsonDate)
        this.companyId = jsonDate.companyId
        this.companyName = jsonDate.companyName
        this.texIdNumber = jsonDate.texIdNumber
        this.businessArea = jsonDate.businessArea
        this.note = jsonDate.note
        this.applyId = jsonDate.applyId
        this.isDisable = jsonDate.isDisable
    }

}

export class ReqDepartmentAdd {
    constructor({ companyId, departmentName, managerDepartmentId, isDisable, creatAccountId }) {
        this.companyId = companyId
        this.departmentName = departmentName
        this.managerDepartmentId = managerDepartmentId
        this.isDisable = isDisable
        this.creatAccountId = creatAccountId
    }
    /*
    constructor(companyName) {
        this.companyName = companyName;
    }
    */

    fromJson(jsonDate) {
        this.companyId = jsonDate.companyId
        this.departmentName = jsonDate.departmentName
        this.managerDepartmentId = jsonDate.managerDepartmentId
        this.isDisable = jsonDate.isDisable
        this.creatAccountId = jsonDate.creatAccountId
    }

}

export class ReqDepartmentDetail {
    constructor({ companyId, departmentId }) {
        this.companyId = companyId
        this.departmentId = departmentId
    }
    /*
    constructor(companyName) {
        this.companyName = companyName;
    }
    */

    fromJson(jsonDate) {
        this.companyId = jsonDate.companyId
        this.departmentId = jsonDate.departmentId
    }

}

export class RespDepartmentDetail {
    constructor({ companyId, departmentId, departmentName, managerDepartmentId, isDisable, categoryId="", creatAccountId }) {
        this.companyId = companyId
        this.departmentId = departmentId
        this.departmentName = departmentName
        this.managerDepartmentId = managerDepartmentId
        this.isDisable = isDisable
        this.categoryId = categoryId
        this.creatAccountId = creatAccountId
    }
    /*
    constructor(companyName) {
        this.companyName = companyName;
    }
    */

    fromJson(jsonDate) {
        this.companyId = jsonDate.companyId
        this.departmentId = jsonDate.departmentId
        this.departmentName = jsonDate.departmentName
        this.managerDepartmentId = jsonDate.managerDepartmentId
        this.managerDepartmentName = jsonDate.managerDepartmentName
        this.isDisable = jsonDate.isDisable
        this.categoryId = jsonDate.categoryId
        this.categoryName = jsonDate.categoryName
        this.creatAccountId = jsonDate.creatAccountId
    }
}


export class ReqUpdateDepartment {
    constructor({ companyId, departmentId, departmentName, managerDepartmentId, isDisable, categoryId}) {
        this.companyId = companyId
        this.departmentId = departmentId
        this.departmentName = departmentName
        this.managerDepartmentId = managerDepartmentId
        this.isDisable = isDisable
        this.categoryId = categoryId
    }

    fromJson(jsonDate) {
        this.companyId = jsonDate.companyId
        this.departmentId = jsonDate.departmentId
        this.departmentName = jsonDate.departmentName
        this.managerDepartmentId = jsonDate.managerDepartmentId
        this.isDisable = jsonDate.isDisable
        this.categoryId = jsonDate.categoryId
    }
}